import { render, staticRenderFns } from "./GardenerSchedule.vue?vue&type=template&id=2878849a"
import script from "./GardenerSchedule.vue?vue&type=script&lang=js"
export * from "./GardenerSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports